import { Button } from '@mantine/core';
import { variants, Modal } from '@uag/react-core';
import { Trans, useTranslation } from 'react-i18next';
import { create, InstanceProps } from 'react-modal-promise';

type Props = {
    currentResponsible: string;
} & InstanceProps<void>;

const ChangeResponsibleModal = ({ currentResponsible, isOpen, onResolve, onReject }: Props) => {
    const { t } = useTranslation();

    const submit = () => onResolve();
    const reject = () => onReject();

    return (
        <Modal opened={isOpen} size="lg" title={`${t('manageRequest')}?`} onAbort={reject} onClose={reject}>
            <div className="modal-description">
                <Trans i18nKey="managedByOther" values={{ currentResponsible }} />
            </div>
            <Modal.Footer>
                <Button className="modal-action" variant={variants.button.secondary} onClick={reject}>
                    {t('cancel')}
                </Button>
                <Button className="modal-action" onClick={submit}>
                    {t('manageRequest')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};

export const openChangeResponsibleModal = create(ChangeResponsibleModal);
